import "regenerator-runtime/runtime";
import _asyncToGenerator from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import _Array$from from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/core-js/array/from";
import _objectSpread from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import GiftPop from './GiftPop';
import service from '../services/service';
import moment from 'moment';
export default {
  name: 'leaderboard',
  components: {
    GiftPop: GiftPop
  },
  data: function data() {
    return {
      list: [],
      visible: false,
      customList: [{
        name: "name",
        title: "姓名",
        type: 1,
        value: ""
      }, {
        name: "tel",
        title: "手机号",
        type: 1,
        value: ""
      }, {
        name: 'uin',
        title: 'qq',
        type: 1,
        value: ""
      }],
      customUserInfo: {},
      title: '对对碰锦鲤收集',
      userInfoVisible: false,
      allEggCount: 0
    };
  },
  computed: _objectSpread({}, mapGetters(['userInfo', 'leaderboardList', 'now']), {
    avatar: function avatar() {
      if (this.userInfo) {
        return this.userInfo.headurl;
      } else {
        return '//vm.gtimg.cn/tencentvideo/vstyle/newvip/style/h5/imgs/common/head_default.svg';
      }
    },
    nick: function nick() {
      return this.userInfo && this.userInfo.nick || '';
    },
    time: function time() {
      return this.setting.截止时间;
    },
    isOfficial: function isOfficial() {
      return this.now < moment(window.setting.活动结束时间).valueOf();
    }
  }),
  filters: {
    nickDash: function nickDash(nickname) {
      if (!nickname) return '**';

      var nickArr = _Array$from(nickname);

      return nickArr[0] + '**' + nickArr[nickArr.length - 1];
    }
  },
  methods: {
    setUserInfo: function () {
      var _setUserInfo = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return service.setUserInfo(this.customUserInfo);

              case 2:
                res = _context.sent;

                if (res.ret === 0) {
                  this.toast('保存成功');
                  this.userInfoVisible = false;
                } else {
                  this.toast(res.msg || '保存失败');
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setUserInfo() {
        return _setUserInfo.apply(this, arguments);
      }

      return setUserInfo;
    }(),
    open: function () {
      var _open = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.userInfoVisible = true;
                _context2.next = 3;
                return service.getUserInfo();

              case 3:
                res = _context2.sent;

                if (res.ret === 0) {
                  this.customUserInfo = res.data.user_info;
                  this.title = res.data.msg_title;
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3() {
      var res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return service.getAllEggCount();

            case 2:
              res = _context3.sent;

              if (res.ret === 0) {
                this.allEggCount = res['all_egg_count'];
              }

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  settingKey: '锦鲤',
  setting: {
    截止时间: '12月23日23:59分'
  }
};